export const getErrorMessage: (err: any) => string = (err: any) => (
    (err.response && err.response.data) ? err.response.data.message : ''
);
